<lib-datepicker
    [formControl]="formControl"
    [withoutMaxDate]="true"
    inputDatetimeFormat="yyyy-MM-dd"
    class="size-s"
    mode="inline-single"
></lib-datepicker>
